import { ShowBase, useShowContext } from "ra-core";
import { JobDetail } from "./JobDetail";

function Content() {
  const { record, isPending } = useShowContext<any>();
  if (isPending || !record) return null;
  return <JobDetail jobId={record.id} />;
}

export function JobShow() {
  return (
    <ShowBase>
      <Content />
    </ShowBase>
  );
}
